<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '求人確認' }]"
        title="掲載済みの求人・応募フォームタイプ設定"
      />
      <!-- 掲載中の求人プレビュー -->
      <section class="margin-top-1">
        <h3 class="boss-joboffer-title boss-setting">
          掲載中の求人情報プレビュー
        </h3>
        <preview-job-published-jobs
          :jobs="jobs"
        />
      </section>
      <!-- 過去の求人プレビュー -->
      <section class="margin-top-1">
        <h3 class="boss-joboffer-title boss-setting">
          過去の求人情報プレビュー
        </h3>
        <p class="boss-text margin-top-0 margin-bottom-1">
          過去5年間に掲載した求人情報を閲覧できます。
        </p>
        <preview-job-published-past-jobs
          :recent-past-jobs="recentPastJobs"
          :past-jobs="pastJobs"
        />
      </section>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>
<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import PreviewJobPublishedJobs from '@/components/organisms/PreviewJobPublishedJobs'
import PreviewJobPublishedPastJobs from '@/components/organisms/PreviewJobPublishedPastJobs'
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  components: {
    SettingHeader,
    PreviewJobPublishedJobs,
    PreviewJobPublishedPastJobs
  },
  data () {
    return {
      jobs: [],
      publishedFolders: []
    }
  },
  computed: {
    pastJobObjects () {
      return this.publishedFolders.map(v => {
        const date = { folderChildId: v.folderChildId, firstDate: v.firstDate, lastDate: v.lastDate }
        const dateMergedJobs = v.pastJobs.map(pastJob => {
          return { ...pastJob, ...date }
        })
        return {
          jobs: dateMergedJobs
        }
      })
    },
    recentPastJobs () {
      return this.pastJobObjects.filter(v => !_.isEmpty(v.jobs))[0]?.jobs ?? []
    },
    pastJobs () {
      return this.pastJobObjects.flatMap(v => v.jobs)
    }
  },
  created () {
    this.storeMaster('entryFormTypes')
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.fetchPublishJobs()
      this.fetchPastJobs()
    },
    ...mapActions([
      'storeMaster'
    ]),
    fetchPublishJobs () {
      this.$http.secured.get('/preview/confirm/jobs').then(response => {
        this.$set(this, 'jobs', response.data.jobs)
      })
    },
    fetchPastJobs () {
      this.$http.secured.get('/preview/confirm/past_jobs').then(response => {
        this.$set(this, 'publishedFolders', response.data)
      })
    }
  }
}
</script>
